/**
 * Selectors for tethering
 */

import { TETHERING_KEY } from './reducers';
import { getConfigParameter } from '../config-params/selectors';

/**
 * Determine whether the application is currently in tethering mode
 * @param state current Redux state
 * @returns {boolean} true if tethering
 */
export const isTethering = state => !!state.getIn([TETHERING_KEY, 'isTethering']);

/**
 * Get the last question that was tethered
 * @param state
 * @returns {*}
 */
export const getLastTetheredQuestion = state => {
    if (!isTethering(state)) {
        return null;
    }
    return state.getIn([TETHERING_KEY, 'lastQuestion'], null);
};

export const getVideo = state => state.getIn([TETHERING_KEY, 'video']);

export const getTetheringSessionName = state => state.getIn([TETHERING_KEY, 'sessionName']);

export const getTetheringAssetURL = state => state.getIn([TETHERING_KEY, 'assetUrl']);

/**
 * Determines whether tethering is configured in the config parameters.
 * Different from isTethering above, as this will be true even if the user
 * is on the login page before tethering has started
 * @param state
 * @returns {boolean}
 */
export const isTetheringModeEnabled = state => {
    const allowedActions = getConfigParameter(state, 'allowedActions');
    if (!allowedActions) {
        return false;
    }
    return allowedActions.indexOf('tethering') !== -1;
};

export const isTetheringCheckingMode = state => state.getIn([TETHERING_KEY, 'checking']);

export const getLastTetherID = state => state.getIn([TETHERING_KEY, 'previousTetherID']);
